// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_modal__y343t {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--table-row-white);
  border-radius: 10px;
  width: 740px;
  max-height: 90vh;
  overflow: auto;

  @media (max-width: 1024px) {
    width: calc(80% - 20px);
  }

  @media (max-width: 760px) {
    width: calc(100% - 20px);
  }
}

.styles_container__nmC4z {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  width: 100%;
  padding: 24px;
  gap: 15px;
}

.styles_header__KTqsr {
  display: flex;
  gap: 20px;
  margin-bottom: 25px;
  @media (max-width: 600px) {
    display: block;
  }
}

.styles_title__KR5R4 {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.styles_title__KR5R4 > div {
  display: flex;
  gap: 4px;
  @media (max-width: 520px) {
    display: block;
  }
}

.styles_title_group__DUnCe {
  font-size: 18px;
  font-weight: 500;
}

.styles_title_machine__t\\+cpu {
  font-size: 20px;
  font-weight: 500;
}

.styles_content__30\\+pY {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 30px;
}

.styles_description__3B9jH {
  display: flex;
  flex-direction: column;
  width: 48%;
  gap: 20px;

  @media (max-width: 1024px) {
    width: 100%;
    margin-bottom: 20px;
  }
}

.styles_description_title__exbfz {
  font-size: 16px;
  opacity: 0.5;
  font-weight: 500;
}

.styles_description_task__-ohxR {
  font-size: 14px;
  font-weight: 700;
}

.styles_description_task__desc__Nr4f9 {
  font-size: 14px;
  font-weight: 500;
}

.styles_fields__UVxuj {
  display: flex;
  flex-direction: column;
  width: 48%;
  gap: 20px;

  @media (max-width: 1024px) {
    width: 100%;
  }
}

.styles_completed__0mm\\+R {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-end;
  height: 29px;
  padding: 0 13px;
  border-radius: 8px;
}

.styles_comments__JDc8x {
  font-size: 16px;
  font-weight: 500;
}

.styles_button_group__TZ2jo {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
  gap: 10px;
  padding: 5px 0;
}
`, "",{"version":3,"sources":["webpack://./src/components/ModalMaintenanceTask/styles.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wCAAwC;EACxC,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;;EAEd;IACE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR;IACE,cAAc;EAChB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,SAAS;;EAET;IACE,WAAW;IACX,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,SAAS;;EAET;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;EACT,cAAc;AAChB","sourcesContent":[".modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: var(--table-row-white);\n  border-radius: 10px;\n  width: 740px;\n  max-height: 90vh;\n  overflow: auto;\n\n  @media (max-width: 1024px) {\n    width: calc(80% - 20px);\n  }\n\n  @media (max-width: 760px) {\n    width: calc(100% - 20px);\n  }\n}\n\n.container {\n  display: flex;\n  box-sizing: border-box;\n  flex-direction: column;\n  width: 100%;\n  padding: 24px;\n  gap: 15px;\n}\n\n.header {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 25px;\n  @media (max-width: 600px) {\n    display: block;\n  }\n}\n\n.title {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n}\n\n.title > div {\n  display: flex;\n  gap: 4px;\n  @media (max-width: 520px) {\n    display: block;\n  }\n}\n\n.title_group {\n  font-size: 18px;\n  font-weight: 500;\n}\n\n.title_machine {\n  font-size: 20px;\n  font-weight: 500;\n}\n\n.content {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  margin-bottom: 30px;\n}\n\n.description {\n  display: flex;\n  flex-direction: column;\n  width: 48%;\n  gap: 20px;\n\n  @media (max-width: 1024px) {\n    width: 100%;\n    margin-bottom: 20px;\n  }\n}\n\n.description_title {\n  font-size: 16px;\n  opacity: 0.5;\n  font-weight: 500;\n}\n\n.description_task {\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.description_task__desc {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.fields {\n  display: flex;\n  flex-direction: column;\n  width: 48%;\n  gap: 20px;\n\n  @media (max-width: 1024px) {\n    width: 100%;\n  }\n}\n\n.completed {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-self: flex-end;\n  height: 29px;\n  padding: 0 13px;\n  border-radius: 8px;\n}\n\n.comments {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.button_group {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-top: 20px;\n  gap: 10px;\n  padding: 5px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": `styles_modal__y343t`,
	"container": `styles_container__nmC4z`,
	"header": `styles_header__KTqsr`,
	"title": `styles_title__KR5R4`,
	"title_group": `styles_title_group__DUnCe`,
	"title_machine": `styles_title_machine__t+cpu`,
	"content": `styles_content__30+pY`,
	"description": `styles_description__3B9jH`,
	"description_title": `styles_description_title__exbfz`,
	"description_task": `styles_description_task__-ohxR`,
	"description_task__desc": `styles_description_task__desc__Nr4f9`,
	"fields": `styles_fields__UVxuj`,
	"completed": `styles_completed__0mm+R`,
	"comments": `styles_comments__JDc8x`,
	"button_group": `styles_button_group__TZ2jo`
};
export default ___CSS_LOADER_EXPORT___;
